import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../models/reduxState';
import { isDarkThemeSelector, isTeamsSelector, sourceAppSelector } from '../../../app/selectors/contactUsSelector';
import { EmailField } from '../../presentationalComponents/RequestDetails/EmailField';
import { dispatchUpdateRequest, dispatchUpdateIsEmailValid } from '../../reduxUpdater/dispatchers/requestDispatchers';
import { isEmailEditingModeSelector, isEmailFieldDisabledSelector, isEmailValidSelector } from '../../reduxUpdater/selectors/commonSelectors';
import {
  isRequestDetailsEditModeSelector,
  userEmailSelector,
} from '../../reduxUpdater/selectors/requestSelector';
import { getRequestDetailsStyles } from '../../styles/requestDetailsStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    isEmailEditingMode: isEmailEditingModeSelector(state),
    isEmailFieldDisabled: isEmailFieldDisabledSelector(state),
    isEmailValid: isEmailValidSelector(state),
    isRequestDetailsEditMode: isRequestDetailsEditModeSelector(state),
    sourceApp: sourceAppSelector(state),
    userEmail: userEmailSelector(state),
    isDarkTheme: isDarkThemeSelector(state),
    isTeams: isTeamsSelector(state),
  };
};

const mapDispatchToProps = {
  dispatchUpdateRequest,
  dispatchUpdateIsEmailValid,
};

export const EmailFieldContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(EmailField, getRequestDetailsStyles));
